import React, { useEffect } from "react";


export const DateSetting = () => {
    useEffect(() => {
        //기간설정 버튼들
        $(".date-setting-area .btns a").click(function () {
            $(".date-setting-area .btns a").removeClass("on");
            $(this).addClass("on");
            var idx = $(this).index();
            if (idx == 3) { //직접 기간설정
                $(".date-setting-area .date-input").slideDown("fast");
            } else {
                $(".date-setting-area .date-input").slideUp("fast");
            }
        });
    }, []);
    return (
        <div className="date-setting-area">
            <div className="btns">
                <a>1주일</a>
                <a>1개월</a>
                <a>3개월</a>
                <a className="btn-selfinput">기간설정</a>
            </div>
            <div className="date-input">
                <div className="round-bar">
                    <div className="ipbox"><input type="text" placeholder="선택하세요." readOnly className="date-picker-input pick-num1" data-num="1" /><i></i></div>
                    <u>~</u>
                    <div className="ipbox"><input type="text" placeholder="선택하세요." readOnly className="date-picker-input pick-num2" data-num="2" /><i></i></div>
                </div>
            </div>

        </div>
    );
};
